import { render } from "./course-info.vue?vue&type=template&id=49a03a90&scoped=true"
import script from "./course-info.vue?vue&type=script&lang=js"
export * from "./course-info.vue?vue&type=script&lang=js"

import "./course-info.vue?vue&type=style&index=0&id=49a03a90&scoped=true&lang=scss"

import exportComponent from "F:\\my-work\\company\\yuanxi\\yuanxi-csspw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a03a90"]])

export default __exports__